export default "__VITE_PUBLIC_ASSET__a105ee3f__"